/** If the path starts with the `/nl/` locale specifier then we return it without that specifier.
 * This is so we can query a `WebsitePage` from a `path`, independent of the default locale(NL) or a specified one(`/nl/`)
 */
export const useWebsitePagePath = (path: string) => {
  const variables = computed(() => ({
    websitePage: {
      path: path.startsWith("/nl/") ? path.slice(3) : path,
    }
  }))

  return { websitePagePath: variables };
};
